import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarModification } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'modification';

export const modificationSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarModification(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarModification });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarModification } = modificationSlice.actions;

export const modification = modificationSlice.reducer;
